/**
 * Simple event bus for cross-system communication between Vue 2 and React Assistant
 * Attached to window object for global access
 */

interface EventBus {
  on(event: string, callback: (payload: any) => void): void
  off(event: string, callback: (payload: any) => void): void
  emit(event: string, payload: any): void
}

class TripDashboardEventBus implements EventBus {
  private listeners: Map<string, Set<(payload: any) => void>> = new Map()

  on(event: string, callback: (payload: any) => void): void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set())
    }
    this.listeners.get(event)!.add(callback)
  }

  off(event: string, callback: (payload: any) => void): void {
    const callbacks = this.listeners.get(event)
    if (callbacks) {
      callbacks.delete(callback)
    }
  }

  emit(event: string, payload: any): void {
    const callbacks = this.listeners.get(event)
    if (callbacks) {
      callbacks.forEach(callback => {
        try {
          callback(payload)
        } catch (error) {
          console.error(`Error in event listener for ${event}:`, error)
        }
      })
    }
  }
}

// Create singleton instance and attach to window
const eventBus = new TripDashboardEventBus()

// @ts-ignore - attaching to window
if (typeof window !== 'undefined') {
  // @ts-ignore
  window.tripDashboardEventBus = eventBus
}

export default eventBus
